import { titleCase } from "@multicines/utils";
import React from "react";

import Styles from "./Ticket.styles";
import { TicketProps as Props } from "./Ticket.types";
import useUtils from "hooks/useUtils";

const Ticket: React.FC<Props> = props => {
  const { type, name, label, price, points, className } = props;
  const { formatByCurrency } = useUtils();

  return (
    <Styles className={`Ticket ${className}`} label={label}>
      <div className="Ticket__mobile">
        <p className="Ticket__mobile__type">{type}</p>
      </div>
      <div className="Ticket__content-right">
        <p className="Ticket__quantity">{type}</p>
        <p className="Ticket__label">{titleCase(name ?? "")}</p>
      </div>
      <div className="Ticket__content-left">
        <p className="Ticket__price">
          {label ? label : points ? `${points}pts` : formatByCurrency(price)}
        </p>
      </div>
    </Styles>
  );
};

export default Ticket;
